export default {
    accessToken: null,
    user: null,
    message: null,
    messageWithoutTimeout: null,
    userEntity: null
}
